export type TargetEnv = 'development' | 'qa' | 'staging' | 'production'

const PROJECT_TO_TARGET_ENV: Record<string, TargetEnv> = {
  'zealth-qa': 'qa',
  'zealth-staging': 'staging',
  'zealth-production': 'production',
}

const projectIdToTargetEnv = (projectId: string): TargetEnv => {
  const env = PROJECT_TO_TARGET_ENV[projectId]
  if (!env) {
    throw new Error(
      `Unsupported Firebase project ID: "${projectId}". ` +
        `Expected one of: ${Object.keys(PROJECT_TO_TARGET_ENV).join(', ')}.`
    )
  }
  return env
}

export const resolveTargetEnv = (
  projectId: string,
  useEmulator: boolean
): TargetEnv => {
  if (useEmulator) return 'development'
  return projectIdToTargetEnv(projectId)
}
